import { faExclamationCircle, faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Accordion, Badge, Button, Card, Dropdown, Form, FormControl, Table } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import BaseDialog from "../../../components/dialogs/baseDialog/BaseDialog";
import APIErrorHelper from "../../../helpers/APIErrorHelper";
import ValidationHelper from "../../../helpers/ValidationHelper";
import CamplaCoreService from "../../../services/CamplaCoreService";
import BaseSelect from "../../../components/baseSelect/BaseSelect";
import PluginHelper from "../../../helpers/PluginHelper";

class CSVImport extends React.Component {
  constructor(props) {
    super(props);
    this.fileReader = new FileReader();

    this.semesterOptions = [
      { value: "spring", label: "ModuleClasses.SemesterSpring" },
      { value: "fall", label: "ModuleClasses.SemesterFall" }
    ];
    const semesterMap = new Map();
    this.semesterOptions.forEach(s => semesterMap.set(s.value, s));

    this.validationDefinition = {
      name: {
        defaultValue: "",
        rule: ValidationHelper.isString
      },
      members: {
        defaultValue: [],
        rule: ValidationHelper.isMemberArray
      },
      moduleId: {
        defaultValue: "",
        rule: ValidationHelper.isID
      },
      isFall: {
        defaultValue: true,
        rule: ValidationHelper.isBoolean
      },
      year: {
        defaultValue: parseInt(new Date().getFullYear()),
        initValid: true,
        rule: ValidationHelper.isYear
      }
    };
    this.state = {
      show: false,
      isLoading: false,
      extendedModuleClass: null,
      modulesMap: new Map(),
      semesterMap: semesterMap,
      moduleOptions: [],
      importSuccessful: false,
      validation: ValidationHelper.getValidation(this.validationDefinition),
      dialogApiError: ""
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
    this.onUpload = this.onUpload.bind(this);
    this.fetchData = this.fetchData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.translateOptions = this.translateOptions.bind(this);
    this.resolveModuleById = this.resolveModuleById.bind(this);
    this.validateStudents = this.validateStudents.bind(this);
    this.extractData = this.extractData.bind(this);
    this.detectDataFormat = this.detectDataFormat.bind(this);
    this.loadImportedData = this.loadImportedData.bind(this);
    this.delimiter = this.delimiter.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation)
    });
  }

  translateOptions(t, options) {
    if (Array.isArray(options)) {
      return options.map(o => ({ value: o.value, label: t(o.label) }));
    } else {
      return { value: options.value, label: t(options.label) };
    }
  }

  onHide() {
    this.setState({
      extendedModuleClass: null,
      importSuccessful: false,
      isLoading: false,
      show: false,
      validation: ValidationHelper.getValidation(this.validationDefinition)
    });
  }

  async onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      const userId = CamplaCoreService.getAuthenticatedUser()._id;

      const setupClasses = await PluginHelper.calculateAndCreateClasses(validatedData, userId, () => {
        console.error("Creation of class failed");
        this.setState({
          dialogApiError: APIErrorHelper.getError(
              {status: 500},
              () => this.setState({ dialogApiError: "" }),
              {},
              this.props.t
          )
        });
      })

      if (setupClasses){
        this.props.onCreate({
          class: setupClasses.createdClasses,
          moduleClass: setupClasses.createdModuleClasses
        });
        this.setState({
          extendedModuleClass: null,
          importSuccessful: false,
          isLoading: false,
          show: false,
          validation: ValidationHelper.getValidation(this.validationDefinition)
        });
      }
    }
  }

  resolveModuleById(id) {
    const m = this.state.modulesMap.has(id)
      ? this.state.modulesMap.get(id)
      : this.state.modulesMap.values().next().value;
    return m ? { value: m._id, label: m.name } : null;
  }

  async fetchData() {
    try {
      const modules = await CamplaCoreService.getAllModules();
      const moduleOptions = modules.map(m => ({ value: m._id, label: m.name }));
      const modulesMap = new Map();
      modules.forEach(m => modulesMap.set(m._id, m));
      this.setState({ modulesMap: modulesMap, moduleOptions });
      this.handleChange({
        target: {
          name: "moduleId",
          value: modules[0]._id
        }
      });
    } catch (err) {
      this.setState({
        apiError: APIErrorHelper.getError(
          err,
          () => this.setState({ apiError: "" }),
          {},
          this.props.t
        )
      });
    }
  }

  onUpload(event) {
    this.fileReader.readAsText(event.target.files[0]);
  }

  async validateStudents(rawStudents){
    const existingEmail = new Set();
    const students = [];
    for (let i in rawStudents) {
      if (typeof rawStudents[i]["firstname"] === "undefined"
          || typeof rawStudents[i]["lastname"] === "undefined"
          || typeof rawStudents[i]["email"] === "undefined"
          || !ValidationHelper.isString(rawStudents[i]["firstname"])
          || !ValidationHelper.isString(rawStudents[i]["lastname"])
          || !ValidationHelper.isEmail(rawStudents[i]["email"])) {
        throw new Error("Invalid csv document given");
      }
      rawStudents[i]["email"] = rawStudents[i]["email"].toLowerCase()

      if (!existingEmail.has(rawStudents[i]["email"])){
        existingEmail.add(rawStudents[i]["email"]);
        students.push(rawStudents[i]);
      }
    }
    return students;
  }

  delimiter(csvText) {
    try {
      const t = csvText.split("\n")[0];
      let delArray = [',', ';', '|', '    '];
      let comma, samiclon, pipe, tab;

      delArray.forEach((e, i) => {
        if (i === 0) {
          comma = t.split(e).length;
        } else if (i === 1) {
          samiclon = t.split(e).length;
        } else if (i === 2) {
          pipe = t.split(e).length;
        } else if (i === 3) {
          tab = t.split(e).length;
        }
      });
      let tmpArray1 = [comma, samiclon, pipe, tab]
      let tmpArray = [comma, samiclon, pipe, tab];
      let maxLen = tmpArray.sort((a, b) => b - a)[0];
      let delimiter_i = 0;
      tmpArray1.forEach((e, i) => {
        if (maxLen === e) {
          delimiter_i = i;
        }
      });
      if (delimiter_i === 0) {
        return ',';
      } else if (delimiter_i === 1) {
        return ';';
      } else if (delimiter_i === 2) {
        return '|';
      } else if (delimiter_i === 3) {
        return '    ';
      }
    }catch(err){
      console.error(err);
    }
    return ",";
  }

  async detectDataFormat(rawCSVStudents){
    const separator = this.delimiter(rawCSVStudents);
    const students = [];
    try {
      const lines = rawCSVStudents
          .replaceAll('"', '')
          .split("\n");
      const headers = lines[0]
          .toLowerCase()
          .replace(/ /, "")
          .trim()
          .split(separator)
          .map(i => i.trim());

      const nameMap = new Map();
      for (const field in window.importPatterns){
        headers.forEach(h => {
          if (window.importPatterns[field].indexOf(h) > -1 && !nameMap.has(h)){
            nameMap.set(h, field);
          }
        });
      }

      if (Object.keys(window.importPatterns).length !== nameMap.size){
        throw new Error("Invalid csv document given");
      }

      lines.shift();
      lines.forEach(line => {
        const values = line.trim().split(separator).map(i => i.trim());
        if (values[0].length > 0 && values[1].length > 0 && values[2].length > 0){
          const student = {};
          headers.forEach((h, idx) => {
            const processKey = nameMap.get(h);
            student[processKey] = values[idx]
          });
          students.push(student);
        }
      });
    } catch (err) {
      throw new Error("Invalid csv document given");
    }
    return students;
  }

  async extractData(checkedStudents) {
    const students = await PluginHelper.validateStudentsEmails((await this.validateStudents(checkedStudents)));
    const now = new Date();
    return {
      members: students,
      moduleId: null,
      className: "",
      isFall: now.getMonth() > 7 || now.getMonth() < 1,
      year: now.getFullYear()
    };
  }

  async loadImportedData(data){
    this.setState({ isLoading: true });
    try {
      const importedData = await this.extractData(data);
      const validation = {
        name: {
          defaultValue: importedData.className,
          initValid: false,
          rule: ValidationHelper.isString
        },
        members: {
          defaultValue: importedData.members,
          initValid: true,
          rule: ValidationHelper.isMemberArray
        },
        moduleId: {
          defaultValue: importedData.moduleId ? importedData.moduleId : "",
          initValid: false,
          rule: ValidationHelper.isID
        },
        isFall: {
          defaultValue: importedData.isFall,
          initValid: true,
          rule: ValidationHelper.isBoolean
        },
        year: {
          defaultValue: importedData.year,
          initValid: true,
          rule: ValidationHelper.isYear
        }
      };
      this.setState({
        validation: ValidationHelper.getValidation(validation),
        importSuccessful: true
      });
      this.handleChange({
        target: {
          name: "year",
          value: importedData.year
        }
      });
    } catch (err) {
      const error = APIErrorHelper.getError(
          { status: 412 },
          () => {
            this.setState({ dialogApiError: "" });
          },
          {
            PRECONDITION_FAILED: `${this.props.t("Plugins.CSVImport.ImportError")} (${err.message})`
          },
          null
      );
      this.setState({ dialogApiError: error });
    }
    this.setState({ isLoading: false });
  }

  componentDidMount() {
    this.fetchData();
    this.fileReader.onload = async evt => {
      this.setState({ isLoading: true });
      let students = [];
      try {
        students = await this.detectDataFormat(evt.target.result);
      } catch (err) {
        const error = APIErrorHelper.getError(
            { status: 412 },
            () => {
              this.setState({ dialogApiError: "" });
            },
            {
              PRECONDITION_FAILED: `${this.props.t("Plugins.CSVImport.ImportError")} (${err.message})`
            },
            null
        );
        this.setState({ dialogApiError: error });
      }
      await this.loadImportedData(students);
      this.setState({ isLoading: false });
    };
  }

  render() {
    const { t } = this.props;
    const upload =
      !this.state.importSuccessful && !this.state.isLoading ? (
        <Form>
          <p>
            <b>{t("Plugins.CSVImport.Form.Description")}</b> <br />
            <b>{t("Plugins.CSVImport.Form.GuidelineTextStepFinal")}</b>
          </p>
          <Form.File id="custom-file" label="Custom file input" custom>
            <Form.File.Input
              onChange={this.onUpload}
              accept="text/csv"
            />
            <Form.File.Label
              data-browse={t("Plugins.CSVImport.Form.UploadButton")}
            />
          </Form.File>
        </Form>
      ) : (
        ""
      );
    const loading = this.state.isLoading ? (
      <div>
        <FontAwesomeIcon icon={faCircleNotch} spin />{" "}
        {t("Plugins.CSVImport.Loading")}
      </div>
    ) : (
      ""
    );
    const form = this.state.importSuccessful ? (
      <Accordion defaultActiveKey="0">
        <Card>
          <Card.Header className="pt-0 pb-0 pl-2 pr-2">
            <Accordion.Toggle
              as={Button}
              variant="link"
              className="acc-link"
              eventKey="0"
            >
              <FontAwesomeIcon
                icon={faExclamationCircle}
                className={
                  this.state.validation.name.isValid &&
                    this.state.validation.members.isValid
                    ? "display-none"
                    : "mr-2 color-red"
                }
              />
              <span>{t("Plugins.CSVImport.Form.ToggleClass")}</span>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>
              <Form.Group controlId="formClassName">
                <Form.Label>
                  {t("Plugins.CSVImport.Form.ClassName")}
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder={t(
                    "Plugins.CSVImport.Form.ClassNamePlaceholder"
                  )}
                  value={this.state.validation.name.value}
                  isInvalid={!this.state.validation.name.isValid}
                  onChange={this.handleChange}
                />
                <Form.Control.Feedback type="invalid">
                  {t("Plugins.CSVImport.Form.ValidationError.Name")}
                </Form.Control.Feedback>
              </Form.Group>
              <span>
                {t("Plugins.CSVImport.Form.Students")}
                <Badge variant="secondary" className="ml-1">
                  {this.state.validation.members.value.length}
                </Badge>
              </span>
              <Table size="sm" className="students-table mt-2">
                <thead>
                  <tr>
                    <th>{t("Plugins.CSVImport.Form.ColumnName")}</th>
                    <th>{t("Plugins.CSVImport.Form.ColumnMail")}</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.validation.members.value.map(m => (
                    <tr>
                      <td>{m.name}</td>
                      <td>{m.email}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Card.Header className="pt-0 pb-0 pl-2 pr-2">
            <Accordion.Toggle
              as={Button}
              variant="link"
              className="acc-link"
              eventKey="1"
            >
              <FontAwesomeIcon
                icon={faExclamationCircle}
                className={
                  this.state.validation.moduleId.isValid &&
                    this.state.validation.year.isValid &&
                    this.state.validation.isFall.isValid
                    ? "display-none"
                    : "mr-2 color-red"
                }
              />
              <span>{t("Plugins.CSVImport.Form.ToggleModuleClass")}</span>
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="1">
            <Card.Body>
              <Form.Group controlId="formBasicModules">
                <Form.Label>
                  {t("Plugins.CSVImport.Form.Module")}
                </Form.Label>
                <BaseSelect
                  options={this.state.moduleOptions}
                  placeholder={t(
                    "Plugins.CSVImport.Form.ModulePlaceholder"
                  )}
                  onChange={s =>
                    this.handleChange({
                      target: {
                        name: "moduleId",
                        value: s.value
                      }
                    })
                  }
                  value={this.resolveModuleById(
                    this.state.validation.moduleId.value
                  )}
                />
                <Form.Control
                  type="hidden"
                  isInvalid={!this.state.validation.moduleId.isValid}
                />
                <Form.Control.Feedback type="invalid">
                  {t("Plugins.CSVImport.Form.ValidationError.ModuleId")}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formBasicYear">
                <Form.Label>{t("Plugins.CSVImport.Form.Year")}</Form.Label>
                <FormControl
                  type="number"
                  min={new Date().getFullYear() - 5}
                  max={new Date().getFullYear() + 5}
                  value={this.state.validation.year.value}
                  isInvalid={!this.state.validation.year.isValid}
                  onChange={event =>
                    this.handleChange({
                      target: {
                        name: "year",
                        value: parseInt(event.target.value)
                      }
                    })
                  }
                  onBlur={event => {
                    let val = parseInt(event.target.value);
                    let currentYear = new Date().getFullYear();
                    this.handleChange({
                      target: {
                        name: "year",
                        value:
                          val > currentYear - 5 && val < currentYear + 5
                            ? val
                            : currentYear
                      }
                    });
                  }}
                />
                <Form.Control.Feedback type="invalid">
                  {t("Plugins.CSVImport.Form.ValidationError.Year")}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="formBasicSemester">
                <Form.Label>
                  {t("Plugins.CSVImport.Form.Semester")}
                </Form.Label>
                <BaseSelect
                  isSearchable={false}
                  options={this.translateOptions(t, this.semesterOptions)}
                  onChange={selected => {
                    this.handleChange({
                      target: {
                        name: "isFall",
                        value: selected.value === "fall"
                      }
                    });
                  }}
                  placeholder={t(
                    "Plugins.CSVImport.Form.SemesterPlaceholder"
                  )}
                  value={this.translateOptions(
                    t,
                    this.state.semesterMap.get(
                      this.state.validation.isFall.value ? "fall" : "spring"
                    )
                  )}
                />
                <Form.Control
                  type="hidden"
                  isInvalid={!this.state.validation.isFall.isValid}
                />
                <Form.Control.Feedback type="invalid">
                  {t("Plugins.CSVImport.Form.ValidationError.IsFall")}
                </Form.Control.Feedback>
              </Form.Group>
            </Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    ) : (
      ""
    );
    return (
      <>
        <Dropdown.Item onClick={() => this.setState({ show: true })}>
          {t("Plugins.CSVImport.Button")}
        </Dropdown.Item>
        <BaseDialog
          show={this.state.show}
          onHide={this.onHide}
          title={t("Plugins.CSVImport.Title")}
          dialogApiError={this.state.dialogApiError}
          leftButtonCallback={this.onHide}
          leftButtonText={t("DialogCancel")}
          leftButtonVariant="black"
          rightButtonCallback={this.onSubmit}
          rightButtonText={t("Plugins.CSVImport.Form.Submit")}
          rightButtonVariant="green"
          rightButtonDisabled={!this.state.validation._isValid}
          body={(<>
            {upload}
            {loading}
            {form}
          </>)}
        />
      </>
    );
  }
}

export default withTranslation()(CSVImport);
